module.exports = __webpack_public_path__ + "img/DE00706.4c91e865.png";